var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f5f5f5"}},[_c(_vm.storeDesign,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }